import React, { useEffect, memo } from 'react';
import { useSnackbar, Snackbar as FrontonSnackbar, Snack, SnackButton, Icon } from 'fronton-react';
import { WarningIcon } from '@fronton/icons-react';

export const Snackbar = memo(({ isShow }: { isShow: boolean }) => {
  const { state, addSnack, removeSnack } = useSnackbar();

  useEffect(() => {
    const data = {
      id: `${Math.floor(Math.random() * 100)}`,
      title: 'Не удалось произвести расчет.',
      content: 'Попробуйте еще раз',
      type: 'error',
      time: true,
    };
    if (isShow) {
      addSnack(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShow]);

  return (
    <FrontonSnackbar>
      {state.map(({ id, title, content, type, button, time, wide }) => (
        <Snack
          key={id}
          id={id}
          header={title}
          paragraph={content}
          icon={
            <Icon size={24}>
              <WarningIcon type="outline" color="control-invert" />
            </Icon>
          }
          variant={type}
          wideButton={wide}
          autoHideTimer={time ? 1500 : undefined}>
          {button && <SnackButton onClick={() => removeSnack(id)}>Закрыть</SnackButton>}
        </Snack>
      ))}
    </FrontonSnackbar>
  );
});
